import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/calendar/calendar.module.css";

export default {
  "calendarBottomText": "calendar-module__calendarBottomText_ffRC2W__100",
  "calendarHeader": "calendar-module__calendarHeader_ffRC2W__100",
  "calendarTopText": "calendar-module__calendarTopText_ffRC2W__100",
  "calendarTopTick": "calendar-module__calendarTopTick_ffRC2W__100"
};
      